import styled from 'styled-components';
export var SelectGroup = styled.div.withConfig({
  displayName: "SelectGroup",
  componentId: "sc-1x5azgr-0"
})(["display:block;> div{+ div{margin-left:8px;}}"]);